import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
// import lodash from 'lodash'
// import { stat } from 'fs';
// import firebase from 'firebase'

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        //Baner System
        banerSystem: null,
        // baner top
        homeVerticalTopBaner: null,
        salesVerticalTopBaner: null,
        // baner bottom
        homeVerticalBottomBaner: null,
        salesVerticalBottomBaner: null,
        salesItemBaner: true, // кастомная переменная для релоуда компонента банера в карточках комлпексов
        //server vars
        pageSetup: null,
        indexPage: null,
        actionPage: null,
        newsPage: null,
        salesPage: null,
        flatsPage: null,
        salesMapPage: null,
        howToBy: null,
        howToTake: null,
        bazisFinance: null,
        onlinePage: null,
        ENPFpage: null,
        //Favorite Page
        favoritePage: null,
        favoriteCount: 0,
        // Hypothec 
        hypothecPage: null,
        hypothecCalculatorPage: null,
        //Contacts page
        contactsPage: null,
        contactsCardAnimate: true,
        contactsMapCoords: [],
        pinCoords: {
            lat: null,
            lng: null,
        },
        // BAZIS-CLUB
        bazisClub: null,
        bazisClubItems: null,
        bazisClubCategoryCounter: null,
        //sales vars
        projectItems: null,
        projectItemsDefault: null,
        projectItemsFilter: null,
        projectItemsMap: [],
        projectItemsFilterCity: null,
        cardAnimate: true,
        mapCoords: [],
        MapItemsTheme: 'default',
        MapMarkersPos: [],
        salesCardPage: null,
        salesCardPageID: 'default',

        salesCardContent: null,
        salesCardContentFlats: [],
        salesCardContentFlatsDefault: [],
        salesFlatsLandCardAnimateCards: true,
        salesLandModalData: null,

        saleCardAnimate: true,

        //actions vars
        actionsItems: [],
        actionsItemsDefault: [],
        actionsItemsFilter: [],
        actionCardAnimate: true,
        //news vars
        newsItems: null,
        newsItemsDefault: [],
        newsItemsFilter: [],
        newsCardAnimate: true,
        newsPageCount: 1,
        //video vars
        videoPage: null,
        videoItems: [],
        videoItemsDefault: [],
        videoItemsFilter: [],
        videoCardAnimate: true,
        videPageCount: 1,
        videoHidePaginBtn: false,

        videoItemsSafety: [],
        // project vars
        currentCity: null,
        currentCityArr: null,
        breadCrumbInit: null,
        customCrumbGlobalVar: null,
        pageName: null,
        SETpageID: null,
        hidePaginBtn: false,
        forms: null,
        // MOBILE VARS
        isOpenSendwich: false,
        isOpenFormConsult: false,
        isOpenFormBazisClub: false,
        isOpenFormSignUpProject: false,
        isOpenSalesModal: false,
        flatsLandGridView: true,
        formBazisClubView: false,
        formConsultData: null,
        coockieBanerTopVisible: false,
        titleSite: 'BAZIS-A - один из крупных застройщиков Казахстана. ENJOY LIFE!',

        // STATE ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        crmProjects: null,
        complexesItems: null,
        // STATE ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        filterData: { // переменные для хранения данных фильтрации
            cityCodes: [],
            complexCodes: [],
            roomQuantities: [],
            areaFrom: 1,
            areaTo: 900,
            floorRangeStart: 1,
            floorRangeEnd: 30,
            meterPriceFrom: 1,
            meterPriceTo: 1000000,
            linesOnPage: 30,
            pageNumber: 1,
        },
        flatsPagination: {
            allApartments: 0,
            remainingApartments: 0,
            remainingPages: 0,
        },
        flatsItems: null, // массив квартир из срм
        flatsEmptyMsg: false, // параметр видимости сообщения о пустом поиске квартир согласно параметрам
        pagin_PageNumber: 1, // текущее число страницы пагинации квартир
        hidePaginBtn: false, // параметр скрытия кнопки пагинации
        visibleFilterMobile: false, // параметр включения мобильного фильтра
        FilterResetTrigger: false, // параметр сброса даных фильтра
        visibleCardImgWindow: false,
        cardImgWindowData: null,

        urlRocketLC: 'https://lk01.bazis.kz',
        // https://lk01.bazis.kz
        // https://bazis-a.rocketfirm.digital
        urlCRMuco: 'https://bazis-online.kz/crmc',
        // https://bazis-online.kz/crmc
        // https://demo.uco.kz/crmc

    },
    getters: {
        loadUrlRocketLC: state => state.urlRocketLC,
        loadUrlCRMuco: state => state.urlCRMuco,
        //Baner System
        loadBanerSystem: state => state.banerSystem,
        // Vertical top baners
        loadHomeTopBaner: state => state.homeVerticalTopBaner,
        loadSalesTopBaner: state => state.salesVerticalTopBaner,
        loadSalesItemBaner: state => state.salesItemBaner,
        // loadShuffleTopVerticalBaner: state => state.shuffleTopVerticalBaner,
        // loadShuffleBottomVerticalBnaer: state => state.shuffleBottomVerticalBaner,
        // Pages
        loadPageSetUp: state => state.pageSetup,
        loadIndexPage: state => state.indexPage,
        loadActionPage: state => state.actionPage,
        loadNewsPage: state => state.newsPage,
        loadSalesPage: state => state.salesPage,
        loadFlatsPage: state => state.flatsPage,
        loadSalesMapPage: state => state.salesMapPage,
        loadHowToBy: state => state.howToBy,
        loadHowToTake: state => state.howToTake,
        loadBazisFinancePage: state => state.bazisFinance,
        loadOnlinePage: state => state.onlinePage,
        loadENPFpage: state => state.ENPFpage,
        // Favorite page
        loadFavoritePage: state => state.favoritePage,
        // Hypothec PAGE
        loadHypothecPage: state => state.hypothecPage,
        loadHypothecCalculatorPage: state => state.hypothecCalculatorPage,
        //CONTACTS PAGE
        loadContactsPage: state => state.contactsPage,
        loadContactsCardAnimate: state => state.contactsCardAnimate,
        loadContactsMapCoords: state => state.contactsMapCoords,
        loadPinCoords: state => state.pinCoords,
        // Bazis Club
        loadBazisClub: state => state.bazisClub,
        loadBazisClubItems: state => state.bazisClubItems,
        loadBazisCategoryCounter: state => state.bazisClubCategoryCounter,
        //sales getters
        loadProjectItems: state => state.projectItems,
        loadProjectItemsDefault: state => state.projectItemsDefault,
        loadProjectItemsFilter: state => state.projectItemsFilter,
        loadProjectItemsMap: state => state.projectItemsMap,
        loadProjectItemsFilterCity: state => state.projectItemsFilterCity,
        loadCardAnimateStatus: state => state.cardAnimate,
        loadMapCoords: state => state.mapCoords,
        loadMapItemsTheme: state => state.MapItemsTheme,
        loadMapMarkersPos: state => state.MapMarkersPos,
        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardPageID: state => state.salesCardPageID,

        loadSalesCardContent: state => state.salesCardContent,
        loadSalesCardFlats: state => state.salesCardContentFlats,
        loadSalesCardFlatsDefault: state => state.salesCardContentFlatsDefault,
        loadSalesLandCardAnimate: state => state.salesFlatsLandCardAnimateCards,
        loadSalesLandModalDataArr: state => state.salesLandModalData,

        // loadSaleCardAnimate: state => state.saleCardAnimate,
        //actions getters
        loadActionsItems: state => state.actionsItems,
        loadActionsItemsDefault: state => state.actionsItemsDefault,
        loadActionsItemsFilter: state => state.actionsItemsFilter,
        loadActionCardAnimateStatus: state => state.actionCardAnimate,
        //news getters
        loadNewsItems: state => state.newsItems,
        loadNewsItemsDefault: state => state.newsItemsDefault,
        loadNewsItemsFilter: state => state.newsItemsFilter,
        loadNewsCardAnimateStatus: state => state.newsCardAnimate,
        loadNewsPageCount: state => state.newsPageCount,
        // video getters
        loadVideoPage: state => state.videoPage,
        loadVideoItems: state => state.videoItems,
        loadVideoItemsDefault: state => state.videoItemsDefault,
        loadVideoItemsFilter: state => state.videoItemsFilter,
        loadVideoCardAnimateStatus: state => state.videoCardAnimate,
        loadVideoPageCount: state => state.videoPageCount,
        loadHidePaginBtnVideo: state => state.videoHidePaginBtn,

        loadVideoItemsSafety: state => state.videoItemsSafety,
        // custom getters
        loadCurrentCity: state => state.currentCity,
        loadCurrentCityArr: state => state.currentCityArr,
        loadBreadCrumbInit: state => state.breadCrumbInit,
        loadCustomCrumbGlobal: state => state.customCrumbGlobalVar,
        loadPageName: state => state.pageName,
        loadFavoriteCount: state => state.favoriteCount,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadForms: state => state.forms,
        // Mobile getters
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,
        loadOpenFormSignUpProject: state => state.isOpenFormSignUpProject,
        loadOpenFormBazis: state => state.isOpenFormBazisClub,
        loadSalesModalAction: state => state.isOpenSalesModal,
        loadFormConsultData: state => state.formConsultData,
        loadFormBazisClubView: state => state.formBazisClubView,
        loadSiteTitle: state => state.titleSite,
        loadCockieBanerTopVisible: state => state.coockieBanerTopVisible,

        // GETTERS ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        loadCrmProjects: state => state.crmProjects,
        loadComplexesItems: state => state.complexesItems, // для фильтра по квартирам
        // GETTERS ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        // GETTERS FOR CRM FLATS
        loadFilterData: state => state.filterData, // параметры филтра
        loadFlatsPagination: state => state.flatsPagination, // параметры остаточных значений(счетчиков) пагинации
        loadFlatsItems: state => state.flatsItems, // массив квартир из срм
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg, // параметр видимости сообщения о пустом поиске квартир согласно параметрам
        loadLandFlatsGridView: state => state.flatsLandGridView, // вид стилистики карточек квартир

        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadVisibleCardImgWindow: state => state.visibleCardImgWindow,
        loadCardImgWindowData: state => state.cardImgWindowData,
    },
    actions: {
        getFullSetUpProject({commit}) {
            if (this.state.pageSetup == null || this.state.banerSystem == null || this.state.forms == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings').then(async (response) => {
                        // console.log(response, 'full setup');
                        commit('setBanerSystem', response.data[0].acf);
                        commit('PageSetUp', response.data[1].acf);
                        commit('formsData', response.data[2].acf);
                        resolve('complete');
                    });
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings/254').then(async (response) => {
                        console.log(response, 'full setup');
                        // commit('setBanerSystem', response.data[0].acf);
                        // commit('PageSetUp', response.data[1].acf);
                        // commit('formsData', response.data[2].acf);
                        // resolve('complete');
                    });
                });
            }
        },
        getIndexPageData({commit}) {
            if (this.state.indexPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/247').then(async (response) => {
                        // console.log(response.data.acf, 'index page');
                        commit('indexPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getActionPageData({commit}) {
            if (this.state.actionPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/251').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('actionPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getENPFPage({commit}) {
            if (this.state.onlinePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/3167').then(async (response) => {
                        // console.log(response.data.acf, 'ENPF PAGE');
                        commit('enpfPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getOnlinePageData({commit}) {
            if (this.state.onlinePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/2040').then(async (response) => {
                        // console.log(response.data.acf, 'ONLINE PAGE');
                        commit('onlinePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsPageData({commit}) {
            if (this.state.newsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/249').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('newsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getHowToByPage({commit}) {
            if (this.state.howToBy == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/698').then(async (response) => {
                        // console.log(response.data.acf, 'HOW TO BY');
                        commit('HowToBy', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getHowToTakePage({commit}) {
            if (this.state.howToTake == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1087').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('HowToTake', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // Favorite Page
        getFavoritePage({commit}) {
            if (this.state.favoritePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1064').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('FavoritePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // Hypothec Page
        getHypothecPage({commit}) {
            if (this.state.hypothecPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/948').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('HypothecPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getHypothecCalculatorPage({commit}) {
            if (this.state.hypothecCalculatorPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/950').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('HypothecCalculatorPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisFinancePage({commit}) {
            if (this.state.bazisFinance == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1148').then(async (response) => {
                        // console.log(response.data.acf, 'BAZIS FINANCE');
                        commit('bazisFinancePage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        //BAZIS CLUB ACTIONS
        getBazisClubPageData({commit}) {
            if (this.state.bazisClub == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/700').then(async (response) => {
                        // console.log(response.data.acf, 'PAGE BAZIS CLUB');
                        commit('bazisClubPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisClubItems({commit}) {
            if (this.state.bazisClubItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'bazis_club/?per_page=1000').then(async (response) => {
                        // console.log(response.data, 'ITEMS');
                        commit('bazisClubItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getBazisClubCategoryCounter({commit}) {
            if (this.state.bazisClubCategoryCounter == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/bazis_club_category/?per_page=100').then(async (response) => {
                        // console.log(response)
                        commit('bazisClubCategoryCounter', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        // END BAZIS CLUB
        getSalesPageData({commit}) {
            if (this.state.salesPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/281').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('salesPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getFlatsPageData({commit}) {
            if (this.state.flatsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/286').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('flatsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getSalesMapPageData({commit}) {
            if (this.state.salesMapPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/284').then(async (response) => {
                        // console.log(response.data.acf);
                        commit('salesMapPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            if (this.state.salesCardPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/561').then(async (response) => {
                        // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                        commit('salesCardPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getSalesCardContent({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/projects?slug=' + payload).then(async (response) => {
                    // console.log(response.data, payload, 'TEST')
                    commit('salesCardContent', response.data[0].acf);
                    resolve('complete');
                });
            });
        },
        // END SALES CARD PROMO/LAND
        getContactsPageData({commit}) {
            if (this.state.contactsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/291').then(async (response) => {
                        // console.log(response.data.acf, 'CONTACTS');
                        commit('contactsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // PAGE SALES CARDS / FLATS
        getProjectsItems({commit}) {
            // console.log('stataararar', this.state.projectItems.length)
            if (this.state.projectItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'projects/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array houses')
                        var dataComplexes = []; // Для фильтра по жк (Список исходных кодов жк для СРМ)
                        var dataResp = {complexCodes: []}; // список жк доступных к запросу из СРМ
                        for(var i=0; i < response.data.length; i++) {
                            if (response.data[i].acf.crm_code != null && response.data[i].acf.crm_code != '' && response.data[i].acf.project_stie_flats_filter_init == 'true') {
                                dataResp.complexCodes.push(response.data[i].acf.crm_code); // Сбор параметров для запроса ЖК из СРМ
                                // Для фильтра по жк (Сбор исходных кодов жк для СРМ)
                                dataComplexes.push({
                                    'code': response.data[i].acf.crm_code,
                                    'name' : response.data[i].acf.project_name.name,
                                });
                            }
                        }
                        // console.log(dataResp, dataComplexes)
                        commit('projectItems', response.data); // коммит всех объектов
                        commit('filterCompelxes', dataComplexes); // коммит для фильтра по жк (квартиры)
                        axios.post(window.CRMurl + '/rest/prices/getComplexes', dataResp).then((response) => { // Запрос Данных об объектах из СРМ
                            // console.log(response.data.data, 'ЖК');
                            commit('crmItemsSet', response.data.data);
                        });
                        resolve('complete');
                    });
                });
            }
            
        },
        // ACTIONS CARDS
        getActionsItems({commit}) {
            if (this.state.actionsItems.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'actions/?per_page=100').then(async (response) => {
                        // console.log(response)
                        commit('actionsItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        //NEWS CARDS
        getNewsItems({commit}) {
            if (this.state.newsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news/?start_date=2020-01-01&per_page=8').then(async (response) => {
                        // console.log(response, 'news')
                        commit('newsItems', response.data);
                        commit('newsCountOfPages', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getVideoPage({commit}) {
            if (this.state.videoPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1956').then(async (response) => {
                        // console.log(response.data.acf, 'SETUP')
                        commit('videoPage', response.data.acf)
                        resolve('complete');
                    });
                });
            }
        },
        getVideoItems({commit}) {
            if (this.state.videoItems.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/video/?start_date=2020-01-01&per_page=8').then(async (response) => {
                        // console.log(response.data, 'VIDEO')
                        commit('videoItems', response.data);
                        commit('videoPageCount', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getVideoItemsSafety({commit}) {
            if (this.state.videoItemsSafety.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/video_safety/?start_date=2020-01-01&per_page=100').then(async (response) => {
                        // console.log(response.data, 'VIDEO_safety')
                        commit('videoItemsSafety', response.data);
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        // FLATS FROM CRM
        getFlatsItems({commit}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.post(window.CRMurl + '/rest/prices/getApartments', payload).then((response) => {
                        // console.log(response, response.data.data, 'Квартиры');
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    });
                });
            }
        },
        getFlatsByFilter({commit}, payload) { // FLATS LOAD BY FILTER
            // console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload).then((response) => {
                // console.log(response.data.data, 'Квартиры');
                commit('flatsItemsArr', response.data.data);
            });
        },
        getFlatsByPagination({commit}, payload) { // FLATS LOAD BY pagination with filter and pagePaginNumber params
            console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload).then((response) => {
                // console.log(response.data.data, 'Квартиры после пагинации');
                commit('flatsItemsArrPagination', response.data.data);
            });
        },
        getFlatsPagintationCounters({commit}, payload) {
            axios.post(window.CRMurl + '/rest/prices/getApartmentsCount', payload, {
            }).then((response) => {
                // console.log(payload);
                // console.log(response, 'Счетчик');
                commit('flatsPaginationCountersSet', response.data.data);
            }).catch((error) => {
                console.log(error.response)
            })
        }
    },
    mutations: {
        setProjectFilCity(state, data) {
            // console.log(data, 'teststststststt')
            state.projectItemsFilterCity = data;
            state.salesItemBaner = false;
            setTimeout(() => {
                state.salesItemBaner = true;
            }, 50);
        },
        setBanerSystem(state, data) {
            state.banerSystem = data
        },
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        indexPage(state, data) {
            state.indexPage = data
        },
        actionPage(state, data) {
            state.actionPage = data
        },
        newsPage(state, data) {
            state.newsPage = data
        },
        salesPage(state, data) {
            state.salesPage = data
        },
        flatsPage(state, data) {
            state.flatsPage = data
        },
        salesMapPage(state, data) {
            state.salesMapPage = data
        },
        HowToBy(state, data) {
            state.howToBy = data
        },
        HowToTake(state, data) {
            state.howToTake = data
        },
        enpfPage(state, data) {
            state.ENPFpage = data;
        },
        onlinePage(state, data) {
            state.onlinePage = data
        },
        FavoritePage(state, data) {
            state.favoritePage = data
        },
        HypothecPage(state, data) {
            state.hypothecPage = data
        },
        HypothecCalculatorPage(state, data) {
            state.hypothecCalculatorPage = data
        },
        bazisFinancePage(state, data) {
            state.bazisFinance = data
        },
        //contacts page
        contactsPage(state, data) {
            state.contactsPage = data
        },
        setContactsCardAnimation(state, data) {
            state.contactsCardAnimate = data
        },
        filterContactsMapCoords(state, data) {
            state.contactsMapCoords = data
        },
        setContactsPinCoords(state, data) {
            // console.log(data)
            state.pinCoords.lat = data.lat,
            state.pinCoords.lng = data.lng
        },
        //BAZIS CLUB
        bazisClubPage(state, data) {
            state.bazisClub = data
        },
        bazisClubItems(state, data) {
            state.bazisClubItems = [];
            var i;
            for (i = 0; i < data.length; i++) {
                state.bazisClubItems.push(data[i].acf);
            }
            // console.log(state.bazisClubItems, 'ITEMS');
        },
        bazisClubCategoryCounter(state, data) {
            state.bazisClubCategoryCounter = [];
            var i;
            var obj = {};
            for (i=0; i < data.length; i++) {
                obj[data[i].slug] = data[i].count;
                // this.counterArr.push({name: response.data[i].count});
            }
            state.bazisClubCategoryCounter = obj;
            // console.log(state.bazisClubCategoryCounter);
            // this.counterArr.push(obj);
        },
        //END BAZIS CLUB
        //SALES MUTATIONS
        projectItems(state, data) {
            var dataARR = [];
            state.projectItems = [];
            state.projectItemsDefault = [];
            state.projectItemsFilter = [];
            state.projectItemsMap = [];
            var i;
            // console.log(data);
            for (i = 0; i < data.length; i++) {
                if (data[i].acf.project_name.slug != 'yassytower') {
                    dataARR.push(Object.assign(data[i].acf, {
                        id: data[i].id,
                    }));
                }
            }
            state.projectItems = dataARR;
            state.projectItemsMap = dataARR;
            state.projectItemsDefault = dataARR;
            state.projectItemsFilter = dataARR;
            // state.projectItems = data;
        },
        filterProjectsItems(state, data) {
            state.projectItems = data;
        },
        filterProjectsItemsMap(state, data) {
            state.projectItemsMap = data;
        },
        filterFlatsCity(state, data) {
            state.filterFlatsCity = data;
        },
        cardAnimateSet(state, data) {
            state.cardAnimate = data
        },
        filterMapCoords(state, data) {
            state.mapCoords = data
        },
        filterMapItemsTheme(state, data) {
            state.MapItemsTheme = data
        },
        marMarkerPos(state, data) {
            state.MapMarkersPos = data
        },
        salesCardPageIDset(state, data) {
            state.salesCardPageID = data;
        },
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            // state.salesCardContent = [];
            state.salesCardContent = data;
            // state.saleCardAnimate = true;
        },
        clearSalesLandCardContent(state, data) {
            state.salesCardContent = null;  
            // console.log('clear sales card land content');
        },
        salesCardContentFlats(state, data) { // sales land page flats
            var flatsArr = [];
            state.salesCardContentFlats = [];
            state.salesCardContentFlatsDefault = [];
            for (var i = 0; i < data.length; i++) {
                flatsArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                    slug: data[i].slug,
                    type: data[i].acf.flats_card_name.split(",")[1].replace(' ','')
                }));
            }
            const shortByMinPrice = _(flatsArr)
                .groupBy('type')
                .map((group) => _.minBy(group, 'flats_card_price_min'))
                .value();

            // console.log(shortByMinPrice, 'RESULT');

            state.salesCardContentFlats = shortByMinPrice;
            state.salesCardContentFlatsDefault = shortByMinPrice;
            // console.log(state.salesCardContentFlats, 'FLATS STORE');
        },
        SalesFlatsCardAllClear(state, data) {
            state.salesCardContentFlats = [];
            state.salesCardContentFlats = data;
        },
        SalesFlatsAnimateCards(state, data) {
            state.salesFlatsLandCardAnimateCards = data;
        },
        salesLandModalDataArrr(state, data) {
            state.salesLandModalData = data;
            // console.log(state.salesLandModalData, 'TEST MODAL DATA')
        },
        salesCardContentFlats_filter(state, data) { // sales land page flats FILTER
            state.salesCardContentFlats = data;
        },
        resetSaleCardContent(state, data) {
            state.salesCardContent = data;
        },
        setAnimateSaleCard(state, data) {
            state.saleCardAnimate = data
        },
        //ACTIONS MUTATIONS
        actionsItems(state, data) {
            state.actionsItems = [];
            var i;
            for (i = 0; i < data.length; i++) {
                state.actionsItems.push(data[i].acf);
                state.actionsItemsDefault.push(data[i].acf);
                state.actionsItemsFilter.push(data[i].acf);
            }
            // state.projectItems = data;
        },
        filterActionsItems(state, data) {
            state.actionsItems = data;
        },
        ActionCardAnimateSet(state, data) {
            state.actionCardAnimate = data
        },
        //news MUTATIONS
        newsItems(state, data) {
            state.newsItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.newsItems.push(items[i]);
                state.newsItemsDefault.push(items[i]);
                state.newsItemsFilter.push(items[i]);
            }
            // console.log(items, 'IETMS SUKA')
            // console.log(state.newsItems, 'ITEMS BUGAA')
            // state.projectItems = data;
        },
        newsPaginate(state, data) {
            // console.log(data);
            // state.newsItems = data;
        },
        filterNewsItems(state, data) {
            state.newsItems = data;
        },
        newsCardAnimateSet(state, data) {
            state.newsCardAnimate = data
        },
        newsCountOfPages(state, data) {
            state.newsPageCount = data
        },
        // NEWS MUTATIONS
        //Video mutations
        videoPage(state, data) {
            state.videoPage = data
        },
        videoItems(state, data) {
            // state.videoItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItems.push(items[i]);
                state.videoItemsDefault.push(items[i]);
                state.videoItemsFilter.push(items[i]);
            }
        },
        videoItemsSafety(state, data) {
            // state.videoItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItemsSafety.push(items[i]);
            }
        },
        videoPageCount(state, data) {
            state.videoPageCount = data
        },
        videoHidePaginate(state, data) {
            state.videoHidePaginBtn = data
        },
        filterVideoItems(state, data) {
            state.videoItems = data;
        },
        videoCardAnimateSet(state, data) {
            state.videoCardAnimate = data
        },
        // project mutations
        CurrentCity(state, data) {
            state.currentCity = data
        },
        CurrentCityArr(state, data) {
            state.currentCityArr = data
        },
        breadCrumbInt(state, data) {
            state.breadCrumbInit = data
        },
        setCustomCrumb(state, data) {
            state.customCrumbGlobalVar = data
        },
        setPageName(state, data) {
            state.pageName = null;
            state.pageName = data;
        },
        setFavoriteCount(state, data) {
            state.favoriteCount = data
        },
        HidePaginBtn(state, data) {
            state.hidePaginBtn = data
        },
        formsData(state, data) {
            state.forms = data
        },
        // MOBILE MUTATIONS
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        Open_form_bazis_Club(state, data) {
            state.isOpenFormBazisClub = data
        },
        Open_form_SignUp_Project(state, data) {
            state.isOpenFormSignUpProject = data
        },
        openSalesModalAction(state, data) {
            state.isOpenSalesModal = data
        },
        set_view_bazis_Club_form(state, data) {
            state.formBazisClubView = data
        },
        getFormConsultData(state, data) {
            state.formConsultData = data
        },
        gridViewFlatsCardSet(state, data) {
            state.flatsLandGridView = data;
        },
        coockieBanerTopVisible(state, data) {
            state.coockieBanerTopVisible = data;
        },
        removePageLoaderImg() {
            var loader = document.getElementById('loader');
            if (loader != undefined) {
                loader.classList.remove("InitLoader");
                setTimeout(()=>{
                    loader.remove();
                },1000);
            }
        },
        
        // МУТАЦИИ ДЛЯ ОБЪЕКТОВ СВЗЯЬ МЕЖДУ ПРОЕКТОМ И СРМ СИСТЕМОЙ
        crmItemsSet(state, data) {
            state.crmProjects = data;
        },
        filterCompelxes(state, data) {
            state.complexesItems = data
        },
        // МУТАЦИИ ДЛЯ ФИЛЬТРА ПО КВАРТИРАМ
        // МУТАЦИИ ПО КВАРТИРАМ СРМ
        FilterDataUpdate(state, data) {
            state.filterData = data
        },
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
                state.hidePaginBtn = true
            } else {
                state.flatsEmptyMsg = false
                state.hidePaginBtn = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            if (data.length < 100) {
                state.hidePaginBtn = true
            }
            // console.log(state.flatsItems);
        },
        flatsPaginationCountersSet(state, data) {
            state.flatsPagination.allApartments = data.allApartments;
            state.flatsPagination.remainingApartments = data.remainingApartments;
            state.flatsPagination.remainingPages = data.remainingPages;
        },
        UpdatePaginPageNumber(state, data) {
            // console.log(data)
            state.pagin_PageNumber = data
        },
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        setVisibleCardImgWindow(state, data) {
            state.visibleCardImgWindow = data
            // console.log(state.visibleCardImgWindow)
        },
        setCardImgData(state, data) {
            state.cardImgWindowData = data
            // console.log(state.cardImgWindowData)
        }
    }
})